export const DEFAULT_FOOTER_TITLE = 'See All';
